import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { prefix, mockPrefix } from './constants';

export const getCompetitorTopicKeywords: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/competitor/topic_keywords`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchChannel: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/competitor/batch_channel`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchLanguage: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/competitor/batch_language`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchRegion: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/competitor/batch_region`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchCountry: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/competitor/batch_country`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchMobileStoreStats: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/store/batch_stats`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchMobileStoreTimeline: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/store/batch_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchPcConsoleStoreTimeline: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/batch_lifetime_pc_console_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchPcConsoleStoreStats: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/batch_lifetime_pc_console`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchTopicTimeLine: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/competitor/batch_topic_stats_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchTopicKeywordTimeLine: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/competitor/batch_keyword_stats_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getCompetitorBatchDauInfo: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/game/batch_dau`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

// Competitor 竞品页面表头信息
export const getCompetitorTableHeader: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/competitor/game`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

// Competitor 排序默认新增竞品接口
export const getCompetitorUpdate: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/competitor/update`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

//Competitor KeyMetrics数据接口
export const getCompetitorKeyMetricsList: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/batch_key_metrics`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

// Competitor 表格话题&关键字区信息
export const getCompetitorMention: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/hero/batch_stats`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};
